/**
 * Given an enumeration object returns a string list of his keys
 * @param e The enumeration form which extract the key list
 * @returns string list of keys
 */
export const getEnumKeyList = (e: any): string[] => {
    return Object.keys(e).map((key) => String(e[key]));
};

export const isString = (text: unknown): text is string => {
    return typeof text === 'string' || text instanceof String;
};

export const isEnum = <T>(key: any, enm: T): key is T[keyof T] => {
    const keyList = getEnumKeyList(enm);
    return keyList.includes(key);
};

export const parseEnum = <T>(id: unknown, enm: T, msg: string): T[keyof T] => {
    if (!isString(id) || !isEnum(id, enm)) {
        const error = getEnumParserErrorMsg(id, enm, msg);
        throw new Error(error);
    }
    return id;
};

// PRIVATE
const getEnumParserErrorMsg = <T>(id: unknown, enm: T, msg: string): string => {
    const keyList = getEnumKeyList(enm);
    return `Incorrect enum value at ${msg}: ${id}, accepted values are: ${keyList.toString()}`;
};
